<template>
  <div class="m-confirmation">
    <b-modal
      :id="id"
      v-model="localActive"
      size="custom-size"
      centered
      hide-footer
      hide-header
      @close="localActive = false"
    >
      <svg
        class="m-confirmation-close"
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="localActive = false"
      >
        <path
          d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
          fill="#8E9CBB"
        />
        <path
          d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
          fill="#8E9CBB"
        />
      </svg>
      <div v-if="modalTitle" class="m-confirmation-title">
        {{ modalTitle }}
      </div>
      <div v-if="modalText" class="m-confirmation-text" v-html="modalText">
        {{ modalText }}
      </div>
      <div v-if="input" class="m-confirmation-input">
        <c-input-old :placeholder="input.placeholder" :clearable="input.clearable" @input="getValue" />
      </div>
      <div v-if="buttons" class="m-confirmation-buttons">
        <c-button
          v-for="(item, index) in buttons"
          :key="index"
          :disabled="item.disabledOnEmptyInput && valueFromInput.length < 1"
          :size="item.size"
          :label="item.label"
          :color="item.color"
          @click="buttonHandler(item.action)"
        />
      </div>
    </b-modal>
  </div>
</template>
<script>
import Button from "@/components/controls/button";
import InputOld from "@/components/controls/input";

export default {
  name: "m-confirmation",
  components: {
    "c-button": Button,
    "c-input-old": InputOld,
  },
  props: ["active", "modalTitle", "modalText", "buttons", "input", "id"],

  data() {
    return {
      localActive: false,
      valueFromInput: "",
    };
  },
  watch: {
    localActive(value) {
      if (!value) {
        this.$emit("close");
      }
    },
    active(value) {
      this.localActive = value;
    },
  },
  methods: {
    closeModal() {
      this.localActive = false;
    },
    deleteEmployee() {
      this.$emit("close");
      this.$emit("deleteEmployee");
    },
    deleteCalc() {
      this.$emit("close");
      this.$emit("deleteCalc");
    },
    buttonHandler(method) {
      if (method === undefined) {
        return;
      }
      this[method]();
    },
    getValue(value) {
      this.valueFromInput = value;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.m-confirmation {
  position: relative;
  width: 100%;
  transition: 0.2s;

  &-title {
    font: 500 18px Fira Sans;
    line-height: 120%;
  }
  @media (max-width: 700px) {
    &-title {
      font-size: 15px;
    }
  }

  &-text {
    margin-top: 20px;
    font: 400 15px Fira Sans;
    line-height: 120%;

    &::v-deep span {
      font-weight: 500;
    }
  }
  @media (max-width: 700px) {
    &-text {
      font-size: 13px;
    }
  }

  &-close {
    position: absolute;
    top: 12px;
    right: 10px;
    cursor: pointer;
  }

  &-input {
    margin-top: 23px;
  }

  &-buttons {
    display: flex;
    margin-top: 29px;
    justify-content: flex-end;

    &::v-deep > .c-button:first-child {
      margin-right: 10px;
    }
    @media (max-width: 700px) {
      &::v-deep > .c-button {
        margin-right: 0 !important;
        width: 50%;
      }

      &::v-deep > .c-button > .c-button__wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        margin: 0 !important;
        border-radius: 0;
      }
    }
  }
  @media (max-width: 700px) {
    &-buttons {
      margin: 30px -20px 0 -20px;
    }
  }
}

::v-deep .modal-custom-size {
  max-width: 590px !important;
}
::v-deep .modal-body {
  padding: 27px 34px 30px 32px;
}
@media (max-width: 700px) {
  ::v-deep .modal-dialog-centered {
    align-items: flex-start;
  }
  ::v-deep .modal-custom-size {
    max-width: 100% !important;
  }
  ::v-deep .modal-body {
    padding: 28px 20px 0 20px;
  }
}
::v-deep .modal-dialog {
  margin: 0 auto;
}
::v-deep .modal.fade .modal-dialog {
  transform: none;
}
</style>
